export default {"src":"/_next/static/media/process-monitoring.a8ecd588.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};